import React from "react";
import { useTranslation } from "react-i18next";
import "../i18n"; // important to import

const InformationSecurity = () => {
  const { t } = useTranslation("InformationSecurity");

  return (
    <>
      <section>
        <div className="page-bg">
          <div className="container">
            <h4>{t("title")}</h4>
          </div>
        </div>
      </section>

      <section className="information-details">
        <div className="container">
          <h6>{t("intro1")}</h6>
          <h6>{t("intro2")}</h6>

          <h5>{t("sectionTitle")}</h5>

          <ul>
            <li>
              <span>{t("highlight1.title")}</span>
              {t("highlight1.description")}
            </li>
            <li>
              <span>{t("highlight2.title")}</span>
              {t("highlight2.description")}
            </li>
            <li>
              <span>{t("highlight3.title")}</span>
              {t("highlight3.description")}
            </li>
            <li>
              <span>{t("highlight4.title")}</span>
              {t("highlight4.description")}
            </li>
            <li>
              <span>{t("highlight5.title")}</span>
              {t("highlight5.description")}
            </li>
            <li>
              <span>{t("highlight6.title")}</span>
              {t("highlight6.description")}
            </li>
          </ul>

          <h6>{t("conclusion")}</h6>
        </div>
      </section>
    </>
  );
};

export default InformationSecurity;
